import { Link } from "react-router-dom";
import TopicCard from "@/components/feature/TopicCard";
import type { Topic } from "@/types";

interface RelatedTopicsProps {
  current: Topic;
  all: Topic[];
}

export default function RelatedTopics({ current, all }: RelatedTopicsProps) {
  const sameCategory = all.filter(
    (item) => item.id !== current.id && item.categoryId === current.categoryId,
  );
  const others = all.filter(
    (item) => item.id !== current.id && item.categoryId !== current.categoryId,
  );
  const related = [...sameCategory, ...others].slice(0, 3);

  if (related.length === 0) return null;

  return (
    <section className="mt-14">
      <div className="flex items-end justify-between gap-3">
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          相关话题推荐
        </h2>
        <Link
          to={`/topics?category=${current.categoryId}`}
          className="whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          同分类更多 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {related.map((topic) => (
          <TopicCard key={topic.id} topic={topic} />
        ))}
      </div>
    </section>
  );
}